import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapRevokeMultiCartMemberResponse } from './multiCartMappers'

type RevokeUserAccessResponse = paths['/api/carts/multi-carts/{multiCartId}/users/{userId}/revoke']['patch']['responses']['200']['content']['application/json']

export function revokeUserAccessMultiCart(cartId: string, userId: string): Promise<{ cartId: string, user: App.MultiCartMember }> {
  return request.patch<RevokeUserAccessResponse, {}>(`/api/carts/multi-carts/${cartId}/users/${userId}/revoke`, {}, { credentials: 'include' }).then(mapRevokeMultiCartMemberResponse)
}
